module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"staff_review":"管理者レビュー","my_review":"私のレビュー"}}')
  delete Component.options._Ctor
}
